import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import TableAHSF from "../../../../Components/TableAHSF";
import Swal from "sweetalert2";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import ObjectivesAdd from "./ObjectivesAdd";
import {
  AddObjectives,
  DeleteObjectives,
} from "../../../../Redux/Reducers/Submitter/Objectives";
import PopupAHSF from "../../../../Components/PopupAHSF";
import { useEffect, useState } from "react";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";

const Objectives = (props) => {
  const [WPB_ObjectivesId, setWPB_ObjectivesId] = useState(null);
  const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
  const lodingAdd = useSelector(
    (state) => state.ObjectivesReducer.ObjectivesAdd
  );
  const lodingDelete = useSelector(
    (state) => state.ObjectivesReducer.DeleteObjectives
  );
  const lodingAEdit = useSelector(
    (state) => state.ObjectivesReducer.ObjectivesEdit
  );

  const AppGuid = useParams();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      // ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
    };
  });
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},


    
    componentBody: (
      <ObjectivesAdd shouldDisableFields={props.shouldDisableFields} />
    ),
    maxWidth: "500px",

    maxHeight: "800px",
    title: "الأهداف",
  };
  const RequestsColumns = [];

  const RequestAccessor = [
    {
      KeyName: "objectivesName",
      ShowStatus: true,
      NmaeColumn: "الهدف",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "schumannsContribution",
      ShowStatus: true,
      NmaeColumn: "مجموع مساهمة شومان",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma:true

    },
  ];

  const OtherMainBtns = [
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then((res) => {
          if (res.isConfirmed == true) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            //delete ow from table by id after confirmed
            console.log(e.tag, "malkkskskskjjsd");

            dispatch(
              DeleteObjectives({
                sU_NT_WPB_ObjectivesId: parseInt(e.target.value),
              })
            );
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: !props.shouldDisableFields,
    },
    {
      Click: async (e) => {
        setWPB_ObjectivesId(e.target.value);
        closePopupEditComponent();
      },
      content: "",
      className: !props.shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];
  const closePopupEditComponent = () => {
    if (PopupComponentEditStatus) {
      setPopupComponentEditStatus(false);
    } else {
      setPopupComponentEditStatus(true);
    }
  };
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [lodingAdd, lodingDelete, lodingAEdit]);
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"sU_NT_WPB_ObjectivesId"}
        valueButtonAction={"sU_NT_WPB_ObjectivesId"}
        URL={`api/SU_NT_WPB_ObjectivesServices/GetAllObjectives`}
        UrlBody={{
          applicationInformationId:
            localStorage.getItem("ApplicationInformationId") ||
            props.applicationGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!props.shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={OtherMainBtns}
        arrayButtonLastIndex={false}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
      />

      <PopupAHSF
        title={"الاهداف"}
        componentBody={
          <ObjectivesAdd
            ViewData={true}
            disabledData={false}
            Action={"edit"}
            WPB_ObjectivesId={WPB_ObjectivesId}
            shouldDisableFields={props.shouldDisableFields}
          />
        }
        maxWidth="500px"
        maxHeight="800px"
        isPopupOpenStatus={PopupComponentEditStatus}
        isPopupOpenFunction={closePopupEditComponent}
      />
    </>
  );
};

export default Objectives;
